export default __webpack_public_path__ + "static/media/2_SE_IPPF_logo_old_edited_color.0f74d5c4.png";